import React, { useRef } from "react";
import { Box } from "@mui/material";
import { useNotify } from "hooks";
import { RecUploadIcon } from "assets/icons";

export const PurchasePdfEmptyData: React.FunctionComponent<{
  documentId: number | null;
  fileName?: any;
}> = ({ fileName, documentId }) => {
  const fileInputRef: any = useRef(null);
  const notify = useNotify();

  const handleFileChange = (e: any) => {
    const files = e.target.files[0];
    fileName(files);
  };

  const handleIconClick = () => {
    if (fileInputRef.current && documentId !== null) {
      fileInputRef.current.click();
    } else {
      notify.error(
        "You have to add data to purchase and save it before add the document",
      );
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <input
        ref={fileInputRef}
        hidden
        accept="application/pdf"
        type="file"
        onChange={handleFileChange}
      />
      <Box
        sx={{
          textAlign: "center",
          position: "absolute",
          backgroundColor: "white",
        }}
      >
        <RecUploadIcon
          width={84}
          height={84}
          onClick={handleIconClick}
          style={{ cursor: "pointer" }}
        />
      </Box>
    </Box>
  );
};
